import { useState, useEffect, useContext } from 'react'
import { FormControl, RadioGroup, FormControlLabel, Radio, Box } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import './MultipleChoiceOption.css'
import { NewQuestionContext, ValidatorContext } from 'containers/Examination/ExaminationContext'

const MultipleChoiceOption = (props) => {
  const { optionSelected, correctAnswer } = props
  const newQuestion = useContext(NewQuestionContext)
  const validator = useContext(ValidatorContext)

  const [options, setOptions] = useState([])

  const [selected, setSelected] = useState('')

  const handleOptionSelect = (e) => {
    setSelected(e.target.value)
    optionSelected(e.target.value)
  }

  const [optionError, setOptionError] = useState(false)

  useEffect(() => {
    setOptionError(false)
    if (validator.validationError.options !== undefined && validator.validationError.options !== "") {
      setOptionError(true)
    }
  }, [validator])

  useEffect(() => {
    if (newQuestion.options !== undefined) {
      setOptions(newQuestion.options)
    }
  }, [newQuestion])

  useEffect(() => {
    setSelected(correctAnswer )
  }, [correctAnswer])

  return (
    <>
      <FormControl component="fieldset" style={{marginTop: '10px'}} fullWidth>
        {optionError && <Alert severity="error">{validator.validationError.options}</Alert>}
        <RadioGroup aria-label="options" value={selected} name="options">
          <Box display="flex" flexWrap="wrap">
            {options.length > 0 && options.map((o) => (
              <Box className="option-item" key={o.id} flexBasis="50%">
                <Box className={o.id === selected ? 'option-highlight' : ''}>
                  <FormControlLabel
                    value={o.id}
                    control={<Radio />}
                    label={<>
                      <span>{o.text}
                        <a href="/"
                          style={{fontWeight: '700', marginLeft: '20px'}}
                          onClick={(e) => {
                            e.preventDefault()
                            newQuestion.removeOption(o.id)
                          }}
                        >
                          [remove option]
                        </a>
                      </span>
                    </>}
                    onChange={handleOptionSelect}
                  />
                  {(o.img !== "" && o.img !== undefined) &&
                    <Box className="option-image">
                      <img className={o.text === "" ? 'no-text' : ''} src={o.img} alt={o.text} />
                    </Box>
                  }
                  <a href="/">
                    <i className="fa fa-times-cirl"></i>
                  </a>
                </Box>
              </Box>
            ))}
          </Box>
        </RadioGroup>
      </FormControl>
    </>
  )
}

export default MultipleChoiceOption